import { render, staticRenderFns } from "./MerchantItem.vue?vue&type=template&id=ec9ec8d8"
import script from "./MerchantItem.vue?vue&type=script&lang=js"
export * from "./MerchantItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports